import production from './environments/production';
import development from './environments/development';

export default () =>
  process.env.NODE_ENV === 'production' ? production() : development();
